import { useCallback, useState } from 'react';

export type ToastState = {
  message: string;
  visible: boolean;
  tone: 'default' | 'accent';
};

export function useToast() {
  const [toast, setToast] = useState<ToastState>({
    message: '',
    visible: false,
    tone: 'default',
  });

  const showToast = useCallback((message: string, tone: 'default' | 'accent' = 'default') => {
    setToast({ message, visible: true, tone });
    window.setTimeout(() => {
      setToast((prev) => ({ ...prev, visible: false }));
    }, 2000);
  }, []);

  return { toast, showToast };
}